import {
  type DBChatParams,
  type DBChat,
  type Chat,
  type ChatInfoMap,
  type ChatQuery,
  type ChatInfo,
  type ChatParams,
  ChatCategory,
} from './types';

export function genDBChat(chat: DBChatParams): DBChat {
  return {
    id: 0,
    category: ChatCategory.SINGLE,
    state: 0,
    receiver_id: '',
    name: '',
    username: '',
    avatar: '',
    ord: 0,
    tag: '',
    latest_msg_relate_id_type: 0,
    latest_msg_relate_id: '',
    last_read_message_id: -1,
    create_at: 0,
    update_at: 0,
    expire_duration: 0,
    ...chat,
  };
}

export function genDBChats(chats: DBChatParams[]) {
  return chats.map(genDBChat);
}

export function genStateChat(chat: ChatParams): Chat {
  const dbChat = genDBChat(chat);
  return {
    ...dbChat,
    user: {
      avatar: dbChat.avatar,
      createdAt: 0,
      disabled: false,
      email: '',
      // key: '',
      name: dbChat.name,
      updatedAt: 0,
      userId: dbChat.receiver_id,
      username: dbChat.username,
      ...chat.user,
    },
    ...chat,
  };
}

export function genStateChats(chats: ChatParams[]) {
  return chats.map(genStateChat);
}

export function getChatInfoByMap(
  map: ChatInfoMap,
  chatKey: ChatQuery
): ChatInfo | undefined {
  return map[chatKey.chat_id];
}
